import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {useProspectPageContext} from "v4/contexts/ProspectPageContext";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";

export default function ProspectHeadingTabPartial({titleSuffix, actions = null}) {
    const {t} = usePolTranslation();
    const {prospect} = useProspectPageContext();
    const {currentRoute} = useNavigation();
    const title = currentRoute?.route?.label;

    return (
        <div className="prospect-tab__listing__header">
            <h2>
                {t(title)}
                {titleSuffix && ` - ${t(titleSuffix)}`}
            </h2>
            {actions && (
                <div className="prospect-tab__actions">
                    {actions({prospect})}
                </div>
            )}
        </div>
    )
}
